import { render, staticRenderFns } from "./AddCategoryItemDialog.vue?vue&type=template&id=379a2d64&scoped=true&"
import script from "./AddCategoryItemDialog.vue?vue&type=script&lang=ts&"
export * from "./AddCategoryItemDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddCategoryItemDialog.vue?vue&type=style&index=0&id=379a2d64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a2d64",
  null
  
)

export default component.exports